import { IconRefresh } from '@tabler/icons';

interface UpdateBannerProps {
  onUpdate: () => void;
}

export function UpdateBanner({ onUpdate }: UpdateBannerProps) {
  return (
    <div
      style={{
        background: '#1971c2',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        height: 40,
        padding: '0 16px',
        fontSize: 13,
        fontFamily: 'Roboto, sans-serif',
      }}
    >
      <span>Nova versão disponível.</span>
      <button
        onClick={onUpdate}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: 'rgba(255, 255, 255, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
          borderRadius: 4,
          color: '#fff',
          cursor: 'pointer',
          fontSize: 12,
          fontFamily: 'inherit',
          fontWeight: 500,
          padding: '3px 10px',
          whiteSpace: 'nowrap',
        }}
      >
        <IconRefresh size={13} />
        Atualizar agora
      </button>
    </div>
  );
}
